export default "__VITE_ASSET__aN$NAI2I__"